import axios from 'axios'

export const baseClient = () => {
	return axios.create()
}

export const authClient = () => {
	return axios.create({
		withCredentials: true,
	})
}

//const DEV = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev'

export const PRO_API = 'https://api.dynasty.rguixaro.dev'

export const SERVER_URL = PRO_API

export const API = `${SERVER_URL}/api`
